import { FunctionComponent, useContext, createContext, useState, ReactNode } from 'react'
import { Alert, AlertColor, Snackbar } from '@mui/material'

interface ToastContext {
  showInfo: (message: string, duration?: number) => void
  showSuccess: (message: string, duration?: number) => void
  showWarn: (message: string, duration?: number) => void
  showError: (message: string, duration?: number) => void
  showWarning: (message: string,duration?: number ) => void;
  // todo hideToast ustga
  hideToast: () => void
}

interface ToastMessage {
  open: boolean
  duration?: number
  message?: string
  severity?: AlertColor
}
interface Props {
  children: ReactNode
}
const toastContext = createContext<ToastContext>({
  showInfo: () => {
    throw new Error('showInfo not implemented')
  },
  showSuccess: () => {
    throw new Error('showSuccess not implemented')
  },
  showWarn: () => {
    throw new Error('showWarn not implemented')
  },
  showError: () => {
    throw new Error('showError not implemented')
  },
  hideToast: () => {
    throw new Error('hide toast not implemented')
  },
  showWarning: () => {
    throw new Error('showWarning not implemented')
  },
})

export const ToastProvider: FunctionComponent<Props> = ({ children }) => {
  const [toast, setToast] = useState<ToastMessage>({ open: false })

  const showToast = (message: string, severity: AlertColor, duration?: number): void => {
    setToast({
      open: true,
      message,
      severity,
      duration
    })
  }

  const hideToast = (): void => {
    setToast({
      ...toast,
      open: false
    })
  }
  return (
    <toastContext.Provider
      value={{
        showInfo: (message, duration) => showToast(message, 'info', duration),
        showSuccess: (message, duration) => showToast(message, 'success', duration),
        showWarn: (message, duration) => showToast(message, 'warning', duration),
        showError: (message, duration) => showToast(message, 'error', duration),
        showWarning: (message, duration) => showToast(message, 'warning', duration),
        hideToast: () => hideToast()
      }}
    >
      {children}
      <Snackbar open={toast.open} autoHideDuration={toast.duration ?? 3000} onClose={hideToast} anchorOrigin={{ horizontal: 'right', vertical: 'top' }}>
        <Alert onClose={hideToast} severity={toast.severity}>
          {toast.message}
        </Alert>
      </Snackbar>
    </toastContext.Provider>
  )
}

export const useToast = (): ToastContext => {
  return useContext(toastContext)
}
